// React
import React, { useContext } from "react";
// React
// CSS
import styles from "./LessonCard.module.css";
// CSS
import { Fade } from "react-awesome-reveal";
import { useNavigate } from "react-router-dom";
import { I_SampleExamLesson } from "../../../../Models/interfaces";
import { SetLessonDataContext } from "../../../../Contexts/SetLessonDataContext";
import { _stringify } from "../../../../Utils/_stringify";
import { SetAllDataNeededContext } from "../../../../Contexts/AllDataNeededContext";
type LessonCardProps = {
  imgUrl: string;
  name: string;
  lessonId: string | number;
  lessonData: I_SampleExamLesson;
  filter: string;
};

const LessonCard: React.FunctionComponent<LessonCardProps> = ({
  imgUrl,
  name,
  lessonId,
  lessonData,
  filter,
}) => {
  const navigate = useNavigate();
  const setLessonData = useContext(SetLessonDataContext);
  const setAllNeededData = useContext(SetAllDataNeededContext);

  return (
    <Fade
      className={`${styles.lessonCardContainer} bg-white p-4 flex flex-col items-center justify-center rounded-lg dark:!text-black`}
    >
      <div
        onClick={() => {
          if (!setLessonData) return;
          setAllNeededData((prevState) => ({
            ...prevState,
            lessonPictureUrl: lessonData.image.url,
          }));
          setLessonData((prevState) => ({ ...prevState, lessonName: name }));
          localStorage.setItem("lessonData", _stringify(lessonData));
          navigate(`/question-bank/${lessonId}/categories`, {
            state: lessonData,
          });
        }}
        className="flex flex-col items-center justify-center rounded-lg"
      >
        <img
          src={String(imgUrl)}
          alt={name}
        />
        <p className="text-xs w-full text-center mt-4">{name}</p>
      </div>
    </Fade>
  );
};

export default LessonCard;
